import Image from '@/components/Image/Image';
import aemClientService from '@/services/aem/aemClientService';
import type {IconModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

type RemoteIconProps = {
    icon?: IconModel | null;
    className?: string;
};

const RemoteIcon = ({icon, className}: RemoteIconProps) => {
    const src = aemClientService.getAssetPath(icon?.path);

    if (!src) return null;

    return (
        <Image src={src} alt={icon?.alt ?? ''} aria-hidden={!icon?.alt} className={twx('object-contain', className)} />
    );
};

export default RemoteIcon;
